module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[58]423.60881fd.woff2";